/**
 * Cliente del proxy /api/ai/completion.
 *
 * El endpoint exige el token de sesión firmado (scope 'session') en
 * Authorization: Bearer — sin sesión (anónimos, kiosco) responde 401 y cada
 * llamador cae a su manejo de error habitual.
 */
import sessionService from './sessionService';

export function postAiCompletion(body: Record<string, unknown>): Promise<Response> {
  const sessionToken = sessionService.getSessionToken();
  return fetch('/api/ai/completion', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(sessionToken ? { Authorization: `Bearer ${sessionToken}` } : {}),
    },
    body: JSON.stringify(body),
  });
}
